module.exports = __webpack_public_path__ + "static/media/testimonial-image-03.d3a690a9.png";